import { types } from "../actions/alert";

const initialState = {
  severity: "warning",
  message: "",
  time: 2000,
  showAlert: false,
};

const alertsReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.ADD: {
      const { showAlert } = payload;
      return {
        ...state,
        showAlert,
      };
    }
    case types.REMOVE:
      const { showAlert } = payload;
      return { ...state, showAlert };

    case types.DETAIL:
      const { severity, message, time } = payload;
      return { ...state, severity, message, time };

    default:
      return state;
  }
};

export default alertsReducer;
